/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deal_Payments_Edit_TitleInputs */

const cs_deal_payments_edit_title = /** @type {(inputs: Deal_Payments_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upravit platbu`)
};

const en_deal_payments_edit_title = /** @type {(inputs: Deal_Payments_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit payment`)
};

/**
* | output |
* | --- |
* | "Edit payment" |
*
* @param {Deal_Payments_Edit_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_payments_edit_title = /** @type {((inputs?: Deal_Payments_Edit_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Payments_Edit_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_payments_edit_title(inputs)
	return cs_deal_payments_edit_title(inputs)
});